export const fieldInputClass =
  'h-9 w-full rounded-md border border-[var(--color-input)] bg-transparent px-2 text-sm focus-visible:ring-2 focus-visible:ring-[var(--color-ring)] focus-visible:outline-none';

export const fieldTextareaClass =
  'w-full rounded-md border border-[var(--color-input)] bg-transparent px-2 py-1.5 text-sm focus-visible:ring-2 focus-visible:ring-[var(--color-ring)] focus-visible:outline-none';

/**
 * A field's label comes from the SCHEMA (`title`), not `t()` — it is
 * tenant-authored content the same way a customer's name or a job's
 * description is, not application UI chrome. Falls back to the raw property
 * key only for a template that never set a title, which is a template
 * authoring gap to fix, not something worth hiding behind a nicer default.
 */
export function FieldLabel({
  htmlFor,
  required,
  children,
}: {
  htmlFor: string;
  required: boolean;
  children: string;
}) {
  return (
    <label htmlFor={htmlFor} className="mb-1 block text-sm font-medium">
      {children}
      {required ? (
        <span aria-hidden="true" className="text-[var(--color-destructive)]">
          {' '}
          *
        </span>
      ) : null}
    </label>
  );
}

export function FieldDescription({ id, text }: { id: string; text?: string }) {
  if (!text) {
    return null;
  }
  return (
    <p id={id} className="mb-1 text-xs text-[var(--color-muted-foreground)]">
      {text}
    </p>
  );
}

export function FieldError({ id, message }: { id: string; message?: string }) {
  if (!message) {
    return null;
  }
  return (
    <p id={id} role="alert" className="mt-1 text-xs text-[var(--color-destructive)]">
      {message}
    </p>
  );
}

export function fieldIds(path: string) {
  const base = `field-${path.replace(/\./g, '-')}`;
  return { inputId: base, descriptionId: `${base}-description`, errorId: `${base}-error` };
}
